import React from 'react';
import { FilterPopover } from "../../components";
import { Form } from 'react-bootstrap';
import { useAuthentication } from "../../hooks";

interface IMatchedPairsFilterProps {
    t: (key: string) => string;
    onApplyFilter: (event: React.FormEvent) => void;
    isLoading: boolean;
    noItems: number;
    setNoItems: (noItems: number) => void;
    createdBy: string;
    setCreatedBy: (createdBy: string) => void
    isSeeAll: boolean;
    setIsSeeAll: (isSeeAll: boolean) => void
}

export const ImageVectorizationFilter: React.FC<IMatchedPairsFilterProps> = ({
    isLoading,
    onApplyFilter,
    t,
    noItems,
    setNoItems,
    createdBy,
    setCreatedBy,
    isSeeAll,
    setIsSeeAll
}) => {
    const handleSetIsSeeAll = () => {
        setCreatedBy("");
        setIsSeeAll(!isSeeAll);
    }

    return (
        <FilterPopover
            id="matched-pairs-filter"
            title={t("OnlyMatchToOEM.FilterTitle")}
            isLoading={isLoading}
            onApplyFilter={onApplyFilter}
            t={t}
        >
            <Form.Group>
                <Form.Label>{t("Config.top_k")}: {noItems}</Form.Label>
                <Form.Range
                    min="1"
                    max="100"
                    step="1"
                    disabled={isLoading}
                    value={noItems}
                    onChange={(e) => setNoItems(parseInt(e.target.value))}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>{t("Vectorization.ViewFromOther")}</Form.Label>
                <Form.Check
                    checked={isSeeAll}
                    type="switch"
                    onChange={handleSetIsSeeAll} />
            </Form.Group>
            <Form.Group>
                <Form.Label>{t("Vectorization.CreatedBy")}</Form.Label>
                <Form.Control
                    disabled={isSeeAll}
                    value={createdBy} type="email"
                    placeholder={t("Vectorization.EmailPlaceholder")}
                    onChange={(e) => setCreatedBy(e.target.value)} />
            </Form.Group>
        </FilterPopover>
    )
}
